import React from "react";

import { FormattedDate, FormattedMessage } from "react-intl";

import Heading from "@atlaskit/heading";
import { Stack, Box, Inline, Text, xcss } from "@atlaskit/primitives";

import { useLoggedInUser } from "@/utils/logged-in-user-provider";

import { OrgSelectorDropdown } from "../org-selector-dropdown";

import { messages } from "./messages";

const headerContainerStyles = xcss({
    borderRadius: "border.radius.200"
});

const getCurrentTimestamp = () => Date.now();

type ContextType = "PARTNER" | "CUSTOMER";

// partner vs customer messaging to complete - in later PR
interface WelcomeBannerProps {
    context?: ContextType;
}

export const WelcomeBanner: React.FC<WelcomeBannerProps> = () => {
    const currentTime = getCurrentTimestamp();
    const userInfo = useLoggedInUser();

    return (
        <Box
            backgroundColor="color.background.accent.teal.subtlest.hovered"
            padding="space.200"
            xcss={headerContainerStyles}
        >
            <Stack space="space.250">
                <Stack>
                    <Text>
                        <FormattedDate
                            weekday="long"
                            day="numeric"
                            month="long"
                            value={currentTime}
                        />
                    </Text>
                    <Heading size="medium">
                        {userInfo?.name ? (
                            <FormattedMessage
                                {...messages.bannerTitleWithName}
                                values={{ name: userInfo.name }}
                            />
                        ) : (
                            <FormattedMessage
                                {...messages.bannerTitleWithoutName}
                            />
                        )}
                    </Heading>
                </Stack>
                <Inline>
                    <OrgSelectorDropdown />
                </Inline>
            </Stack>
        </Box>
    );
};
